<template lang="pug">
.container
  .row
    img(src="@/assets/svg/twitter.svg", alt="Twitter_logo", width="100")
    h1 #TwiLoader
    h5 純日本製・超高速のTwitter動画ダウンローダー
    a(href="#howto") 使い方/注意事項
    .form(v-if="!show && !after_download")
      input.u-full-width(
        type="url",
        placeholder="ツイートURLを入力…",
        v-model="input_url"
      )
      details
        summary ▶保存設定
        label(for="file_name") ファイル名
        input#file_name(
          type="text",
          placeholder="デフォルトはツイートの抜粋",
          v-model="file_name"
        )
        | .mp4
        p 画質は最高画質を自動で選択します.
      button.button-primary(type="button", @click="submit") ダウンロード
      p ※すぐにDLが始まります.
    .result
      b(v-if="after_download") {{ result }}
      br
      a(@click="clear", v-if="after_download") 続けてダウンロード
  About
  Loading(:show="show")
</template>

<script>
import Loading from "./components/Loading.vue";
import About from "./components/About.vue";
import saveAs from "file-saver";

export default {
  name: "App",
  components: {
    Loading,
    About,
  },
  data() {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    this.input_url = params.get("url");
    return {
      show: false,
      result: "",
      after_download: false,
      input_url: this.input_url,
      file_name: "",
    };
  },
  methods: {
    submit: function () {
      this.show = true;
      this.download(this.input_url);
    },
    clear: function () {
      this.show = false;
      this.result = "";
      this.after_download = false;
      this.input_url = "";
      this.file_name = "";
    },
    download: function (_url) {
      this.show = true;
      fetch("https://tools.ic731.net/api/twiloader_api/request.php?url=" + _url)
        .then((response) => response.json())
        .then((data) => {
          if (data.status == "success") {
            this.best = data.variants.reduce((a, b) =>
              a.bitrate > b.bitrate ? a : b
            );
            this.url = this.best.url;
            this.result = "データを取得出来ました.自動でダウンロードされます";
            if (this.file_name == "") {
              this.file_name = data.text;
            }
            this.downloadUrl(this.url, this.file_name + ".mp4");
          } else if (data.status === "not_found") {
            this.result = "ツイートが見つかりませんでした";
          } else if (data.status === "not_video") {
            this.result =
              "動画のツイートではありません.公式アカウントのダウンロードには今後対応予定です.";
          } else {
            this.result = "ダウンロード出来ませんでした";
          }
          this.show = false;
          this.after_download = true;
        });
    },
    downloadUrl: function (url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, filename);
        });
    },
  },
};
</script>

<style lang="scss">
// Load Skeleton CSS
@import "../node_modules/skeleton-css/css/normalize.css";
@import "../node_modules/skeleton-css/css/skeleton.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1 {
  color: dodgerblue;
}

button {
  font-size: 1.5rem;
}

.result b {
  color: #ff0000;
}

.form {
  details {
    margin-bottom: 1rem;
    // 下線
    border-bottom: 1px solid #e0e0e0;
  }
}
</style>
